import React, { FC, useContext } from 'react';
import { ModalRestrictedContainer } from '../modal-container/ModalRestrictedContainer';
import { UserContext } from '../../../../user/UserContext';
import { ExpiredRestrictedModal } from './expired/ExpiredRestrictedModal';

type Props = {
  isOpen: boolean;
  source: string;
  onRequestClose: () => void;
};

export const UserStatusRouter: FC<Props> = ({
  children,
  onRequestClose,
  source,
  isOpen,
}) => {
  const { loggedIn } = useContext(UserContext);
  return (
    <ModalRestrictedContainer onRequestClose={onRequestClose} isOpen={isOpen}>
      {loggedIn ? (
        <ExpiredRestrictedModal source={source} closeModal={onRequestClose} />
      ) : (
        children
      )}
    </ModalRestrictedContainer>
  );
};
